import * as React from "react";
import { Badge } from "@/components/ui/badge";
const partners = [{
  name: "Cisco",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_cisco_partner.png"
}, {
  name: "Hikvision",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_hikvision_partner.png"
}, {
  name: "Microsoft",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_microsoft_partner.png"
}, {
  name: "Dell Technologies",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_dell_partner.png"
}, {
  name: "Fortinet",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_fortinet_partner.png"
}, {
  name: "Ubiquiti",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_ubiquiti_partner.png"
}, {
  name: "ESET",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_eset_partner.png"
}, {
  name: "MikroTik",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592747/img/logo_mikrotik_partner.png"
}];
export default function CertifiedReliability() {
  return <section id="πιστοποιημένη-αξιοπιστία" className="dark bg-background text-foreground py-20 overflow-hidden relative border-y border-border/40">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:3rem_3rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20 pointer-events-none"></div>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center">
        <Badge variant="outline" className="font-mono text-primary border-primary/30 bg-primary/5 mb-16 px-4 py-1.5 text-sm tracking-wider shadow-[0_0_15px_rgba(0,229,255,0.1)] backdrop-blur-sm">
          Οι Τεχνολογικοί μας Συνεργάτες
        </Badge>

        {}
        <div className="w-full flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
          <div className="flex w-max animate-[marquee_40s_linear_infinite] hover:[animation-play-state:paused]">
            {}
            {partners.map((partner, i) => <div key={`set1-${i}`} data-index={i} className="flex items-center justify-center w-48 md:w-64 mx-4 md:mx-8 group cursor-pointer">
                <div className="relative w-full h-20 flex items-center justify-center p-4 rounded-lg border border-transparent transition-all duration-500 group-hover:border-primary/20 group-hover:bg-primary/5 group-hover:shadow-[0_0_20px_rgba(0,229,255,0.05)]">
                  <img src={partner.src} alt={partner.name} className="max-h-12 w-auto object-contain grayscale opacity-40 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110" />
                </div>
              </div>)}
            
            {}
            {partners.map((partner, i) => <div key={`set2-${i}`} data-index={i + partners.length} className="flex items-center justify-center w-48 md:w-64 mx-4 md:mx-8 group cursor-pointer">
                <div className="relative w-full h-20 flex items-center justify-center p-4 rounded-lg border border-transparent transition-all duration-500 group-hover:border-primary/20 group-hover:bg-primary/5 group-hover:shadow-[0_0_20px_rgba(0,229,255,0.05)]">
                  <img src={partner.src} alt={partner.name} className="max-h-12 w-auto object-contain grayscale opacity-40 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110" />
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}